import { render, staticRenderFns } from "./preevision.vue?vue&type=template&id=33c75594"
import script from "./preevision.vue?vue&type=script&lang=js"
export * from "./preevision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports